(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fb-klaviyo-bis-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__fbBisModalInit) return;
    window.__fbBisModalInit = true;

    var REVISION_BIS = '2026-07-15';
    var REVISION_SUB = '2026-04-15';
    var BIS_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions';
    var SUB_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
    var SOURCE = 'Shopify - Back in Stock';
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    var dialog = null;
    var els = {};
    var currentCompany = '';
    var currentVariant = '';
    var currentList = '';

    function build() {
      dialog = document.createElement('dialog');
      dialog.className = 'fb-bis-modal';
      dialog.setAttribute('aria-labelledby', 'fb-bis-modal-title');
      dialog.innerHTML =
        '<div class="fb-bis-modal__inner">' +
          '<button type="button" class="fb-bis-modal__close" aria-label="Close" data-fb-bis-close>&times;</button>' +
          '<h2 class="fb-bis-modal__title" id="fb-bis-modal-title">Notify me when available</h2>' +
          '<div data-fb-bis-form>' +
            '<p class="fb-bis-modal__subtitle" data-fb-bis-subtitle></p>' +
            '<form class="fb-bis-modal__form" novalidate>' +
              '<label class="fb-bis-modal__label" for="fb-bis-email">Email address</label>' +
              '<input class="fb-bis-modal__input" id="fb-bis-email" type="email" name="email" required autocomplete="email" autocapitalize="off" autocorrect="off" placeholder="you@example.com">' +
              '<label class="fb-bis-modal__optin">' +
                '<input type="checkbox" data-fb-bis-optin>' +
                '<span>Keep me posted on new drops &amp; offers.</span>' +
              '</label>' +
              '<button class="fb-bis-modal__submit button" type="submit">Notify me</button>' +
              '<p class="fb-bis-modal__message" data-fb-bis-message role="status" hidden></p>' +
            '</form>' +
            '<p class="fb-bis-modal__fineprint">We’ll email you once when it’s back in stock.</p>' +
          '</div>' +
          '<div class="fb-bis-modal__success" data-fb-bis-success hidden>' +
            '<p class="fb-bis-modal__success-title">You’re on the list! 🎉</p>' +
            '<p class="fb-bis-modal__success-body">We’ll send you an email as soon as it’s back in stock.</p>' +
            '<button type="button" class="fb-bis-modal__submit button" data-fb-bis-close>Done</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(dialog);

      els.formWrap = dialog.querySelector('[data-fb-bis-form]');
      els.successWrap = dialog.querySelector('[data-fb-bis-success]');
      els.subtitle = dialog.querySelector('[data-fb-bis-subtitle]');
      els.form = dialog.querySelector('form');
      els.email = dialog.querySelector('input[type="email"]');
      els.optin = dialog.querySelector('[data-fb-bis-optin]');
      els.submit = els.form.querySelector('.fb-bis-modal__submit');
      els.message = dialog.querySelector('[data-fb-bis-message]');

      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || (e.target.closest && e.target.closest('[data-fb-bis-close]'))) {
          dialog.close();
        }
      });
      els.form.addEventListener('submit', onSubmit);
    }

    function showMessage(text, isError) {
      els.message.textContent = text;
      els.message.hidden = false;
      els.message.setAttribute('role', isError ? 'alert' : 'status');
      els.message.classList.toggle('is-error', !!isError);
    }

    function open(trigger) {
      if (!dialog) build();
      currentCompany = trigger.getAttribute('data-fb-bis-company-id') || '';
      currentVariant = trigger.getAttribute('data-fb-bis-variant-id') || '';
      currentList = trigger.getAttribute('data-fb-bis-list-id') || '';
      var title = trigger.getAttribute('data-fb-bis-product-title') || 'this item';

      // reset to the form state each open
      els.successWrap.hidden = true;
      els.formWrap.hidden = false;
      els.message.hidden = true;
      els.message.textContent = '';
      els.message.classList.remove('is-error');
      els.email.value = '';
      els.optin.checked = trigger.getAttribute('data-fb-bis-optin-default') === 'true';
      els.submit.disabled = false;
      els.subtitle.textContent = 'Enter your email and we’ll let you know when ' + title + ' is back in stock.';

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      setTimeout(function () { els.email.focus(); }, 30);
    }

    // Best-effort marketing-list subscribe — mirrors the fb-klaviyo-signup block.
    function subscribeMarketing(email) {
      if (!currentList) return;
      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: SOURCE,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: currentList } } }
        }
      };
      fetch(SUB_ENDPOINT + '?company_id=' + encodeURIComponent(currentCompany), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION_SUB, accept: 'application/vnd.api+json' },
        body: JSON.stringify(payload)
      }).catch(function () { /* best-effort */ });
    }

    function onSubmit(event) {
      event.preventDefault();
      els.message.hidden = true;

      var email = (els.email.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showMessage('Please enter a valid email address.', true);
        els.email.focus();
        return;
      }
      if (!currentCompany || !currentVariant) {
        showMessage('Notifications aren’t set up right now. Please try again later.', true);
        return;
      }

      els.submit.disabled = true;
      var original = els.submit.textContent;
      els.submit.textContent = 'Submitting…';
      var wantsMarketing = !!(els.optin && els.optin.checked);

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + currentVariant } }
          }
        }
      };

      fetch(BIS_ENDPOINT + '?company_id=' + encodeURIComponent(currentCompany), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION_BIS,
          accept: 'application/vnd.api+json'
        },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (res.ok) {
            if (wantsMarketing) subscribeMarketing(email);
            els.formWrap.hidden = true;
            els.successWrap.hidden = false;
            try {
              if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
                window.klaviyo.identify({ email: email });
              }
            } catch (_e) { /* onsite tracking is best-effort */ }
          } else {
            els.submit.disabled = false;
            els.submit.textContent = original;
            showMessage('Something went wrong. Please try again.', true);
          }
        })
        .catch(function () {
          // A thrown fetch (vs. a non-ok status) almost always means an ad/privacy
          // blocker cancelled the request to a.klaviyo.com — that domain is on
          // uBlock/Brave/AdGuard blocklists. Tell the user so they can act.
          els.submit.disabled = false;
          els.submit.textContent = original;
          showMessage("Couldn't reach the signup server — an ad or privacy blocker may be blocking it. Try pausing it, or use a different browser.", true);
        });
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('.fb-bis-trigger');
      if (!trigger) return;
      event.preventDefault();
      open(trigger);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section"] && !Shopify.designMode) return;
  try {
    class SectionMobileCarousel extends HTMLElement {
    constructor() {
      super();
      this.scroller = null;
      this.dots = [];
      this.slides = [];
      this.currentIndex = 0;
      this.columns = 1;
    }

    connectedCallback() {
      this.scroller = this.querySelector('.section-mobile-carousel__scroller');
      this.dots = [...this.querySelectorAll('.section-mobile-carousel__dot')];
      this.slides = [...this.scroller.children];
      this.columns = parseInt(this.dataset.columns) || 1;

      // Calculate number of "pages" (groups of columns)
      this.pageCount = Math.ceil(this.slides.length / this.columns);

      if (this.slides.length <= this.columns) {
        const dotsContainer = this.querySelector('.section-mobile-carousel__dots');
        if (dotsContainer) dotsContainer.style.display = 'none';
        return;
      }

      // Add click handlers to dots
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => this.goToPage(index));
      });

      // Track scroll position to update dots
      this.scroller.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });

      // Initial state
      this.updateActiveDot(0);
    }

    handleScroll() {
      const scrollLeft = this.scroller.scrollLeft;

      // Calculate page width based on scroller's scroll width and page count
      const scrollWidth = this.scroller.scrollWidth - this.scroller.clientWidth;
      const pageWidth = scrollWidth / Math.max(1, this.pageCount - 1);

      // Determine current page based on scroll position
      const pageIndex = pageWidth > 0 ? Math.round(scrollLeft / pageWidth) : 0;
      const clampedPageIndex = Math.max(0, Math.min(pageIndex, this.pageCount - 1));

      if (clampedPageIndex !== this.currentIndex) {
        this.currentIndex = clampedPageIndex;
        this.updateActiveDot(clampedPageIndex);
      }
    }

    goToPage(pageIndex) {
      // Calculate which slide to scroll to (first slide of the page)
      const slideIndex = pageIndex * this.columns;
      const slide = this.slides[slideIndex];
      if (!slide) return;

      // Scroll to the slide's left edge minus the padding
      const scrollerStyles = getComputedStyle(this.scroller);
      const paddingLeft = parseInt(scrollerStyles.paddingLeft) || 0;

      // Get the slide's offset relative to the scroller's content
      const slideOffset = slide.offsetLeft - this.scroller.offsetLeft - paddingLeft;

      this.scroller.scrollTo({
        left: slideOffset,
        behavior: 'smooth'
      });

      this.currentIndex = pageIndex;
      this.updateActiveDot(pageIndex);
    }

    updateActiveDot(activePageIndex) {
      this.dots.forEach((dot, index) => {
        // For 2-column layout, dots represent pages not individual slides
        // Dot 0 = slides 0-1, Dot 1 = slides 2-3, etc.
        const isActive = index === activePageIndex;
        dot.classList.toggle('section-mobile-carousel__dot--active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('section-mobile-carousel')) {
    customElements.define('section-mobile-carousel', SectionMobileCarousel);
  }
  } catch(e) { console.error(e); }
})();

})();
